<template>
  <div>
  <v-tooltip
    open-delay=1000
    :left="tooltipLeft"
    :right="tooltipRight"
    :top="tooltipTop"
    :bottom="tooltipBottom"
    >
    <template v-slot:activator="{ on }">
      <span v-on="on" v-if="enableToolTip">
        <v-autocomplete
          v-bind="computedProps"
          :placeholder="phtext"
          v-model="innerValue"
          v-on="computedListeners"
          :tabindex="readonly ? -1 : 0"
          :search-input.sync="autocompleteText">
          <template v-slot:label v-if="label !== undefined && label !== null && label !== ''">
            {{ label }}
            <span v-if="required" class="mandatory">必須</span>
          </template>
          <template v-slot:append>

            <v-btn
              icon
              color="primary"
              dark
              elevation="0"
              small
              v-if="!readonly && useHelp"
              tabindex=-1
              @click="onDialogButtonClick">

              <v-icon>mdi-magnify</v-icon>

            </v-btn>

          </template>

        </v-autocomplete>

      </span>
      <v-autocomplete
        v-else
        v-bind="computedProps"
        :placeholder="phtext"
        v-model="innerValue"
        v-on="computedListeners"
        :tabindex="readonly ? -1 : 0"
        :search-input.sync="autocompleteText">

        <template v-slot:label v-if="label !== undefined && label !== null && label !== ''">
          {{ label }}
          <span v-if="required" class="mandatory">必須</span>
        </template>

        <template v-slot:append>

          <v-btn
            icon
            color="primary"
            dark
            elevation="0"
            small
            v-if="!readonly && useHelp"
            tabindex=-1
            @click="onDialogButtonClick">

            <v-icon>mdi-magnify</v-icon>

          </v-btn>

        </template>

      </v-autocomplete>
    </template>
    <span v-html="tooltipText"></span>
  </v-tooltip>

    <dd-master-search-dialog
      :showDialog="showDialog"
      :titleText="titleText"
      :headerList="headerList"
      :itemList="itemList"
      :targetMaster="targetMaster"
      @close="onDialogClosed"/>

  </div>
</template>
<script>
import DdMasterSearchDialog from '@/components/DdMasterSearchDialog'

import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VAutocomplete } from 'vuetify/lib'

/**
 * @file DDv2用オートコンプリートテキストボックス
 * @namespace components
 */

/**
 * @vue-prop {controls.InputTypes} valueType - 入力タイプ
 * @vue-prop {Boolean} [required=false] - 必須指定
 * @vue-prop {Number} [length=999] - 入力可能桁数
 * @vue-prop {String} [errorMessages=''] - 表示エラーメッセージ
 * @vue-prop {String} [paddingChar=''] - 埋め込み文字列
 * @vue-prop {Array} headerList - ダイアログ用ヘッダリスト
 * @vue-prop {String} [returnValueName=''] - 返却値カラム指定
 * @see VDataTable
 * @vue-prop {Array} itemList - オートコンプリート用リスト
 * @vue-prop {String} titleText - ダイアログ用表示タイトル
 * @example
 * <dd-code-text-box
 *    label="取引先コード"
 *     v-model="codeValue"
 *    :length="10"
 *    item-value="hacchakutiCd"
 *    item-text="hachakutiNm"
 *    :valueType="ctypes.InputTypes.Numerical"
 *    titleText="発着地マスタ検索"
 *    :headerList="headers"
 *    :itemList="filteredHacchakuchiList"/>

  computed: {
    ...mapGetters({
      hacchakuchiList: 'DDMasters/mstHacchakuchi'
    }),
    filteredHacchakuchiList () {
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      })
    }
  },
  data: () => ({
    headers: [
      { width: '60px', text: '会社コード', value: 'kaishaCd' },
      { width: '90px', text: '発着地コード', value: 'hacchakutiCd' },
      { width: '90px', text: '適用開始日', value: 'tekiyoStartYmdDisp' },
      { width: '90px', text: '適用終了日', value: 'tekiyoEndYmdDisp' },
      { width: '200px', text: '発着地名', value: 'hachakutiNm' },
      { width: '200px', text: '発着地請求名', value: 'hachakutiNmSei' },
      { width: '200px', text: '発着地（カナ）', value: 'HachakutiNmKn' },
      { width: '200px', text: '取引先コード', value: 'torihikisakiCd' },
      { width: '200px', text: '郵便番号', value: 'yubinNo' },
      { width: '200px', text: '住所', value: 'jusho' },
      { width: '90px', text: '電話番号', value: 'telNo' },
      { width: '200px', text: '取引先担当者', value: 'tantoshaNm' },
      { width: '90px', text: '発着地グループコード', value: 'hacchakutiGroupCd' }
    ]
  })
 */
export default {
  name: 'DdCodeTextBox',
  extends: VAutocomplete,
  mixins: [inputMixin],
  props: {
    /**
     * 入力タイプ
     * @see controls.InputTypes
     */
    valueType: Number,
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能桁数
     */
    length: {
      type: Number,
      default: 999
    },
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * 埋め込み文字
     */
    paddingChar: {
      type: String,
      default: ''
    },
    /**
     * コンプリートリスト
     */
    itemList: Array,
    /**
     * 返却値カラム名
     */
    returnValueName: {
      type: String,
      default: ''
    },
    /**
     *
     */
    code: String,
    /**
     * Dialog用ヘッダリスト
     * @see VDataTable
     */
    headerList: Array,
    /**
     * Dialog表示タイトル
     */
    titleText: String,
    /**
    * 絞り込み対象カラム
    */
    searchColumns: Array,
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    phtext: {
      type: String,
      default: 'コードまたは名称で検索'
    },
    /**
     * 検索ボタン
     */
    useHelp: {
      type: Boolean,
      default: true
    }
  },
  components: {
    DdMasterSearchDialog
  },
  data: () => ({
    hasFocus: true,
    showDialog: false,
    invalidMessage: '',
    innerValue: {},
    autocompleteText: null,
    targetMaster: ''
  }),
  created () {
  },
  mounted () {
    console.log('DdCodeTextBox.mounted', this.itemList, this.lazyValue)
    this.innerValue = this.lazyValue
    const dtl = controls.getInputTypeDetail(this.valueType)
    if (!dtl) { return }
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage)

    if (this.invalidMessage === undefined) {
      // this[controls.VALIDATE_METHOD]()
    }
    // create targetMaster
    this.targetMaster = this.itemValue.replace('Cd', '')
  },
  watch: {
    itemList: function (newlist, oldlist) {
      console.log(newlist)
      this.itemList = newlist
    },
    value (n, o) {
      console.log('dd-code-text-box.watch(value)', o, n)
      if (o === n || n === undefined) { return }
      this.innerValue = n
      this.$emit('input', this.innerValue)
    },
    autocompleteText (value) {
      if (value === '') {
        this.innerValue = null
        this.$emit('input', this.innerValue)
      }
    }
  },
  computed: {
    computedProps () {
      return {
        ...this.$props,
        maxlength: this.length,
        class: this.required ? ' required-item' : this.class,
        hideDetails: 'auto',
        outlined: !this.isReadonly,
        items: this.filteredItems,
        itemValue: this.itemValueName,
        itemText: 'text',
        clearable: false,
        clearIcon: '',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage,
        filter: this.suggestFillter
      }
    },
    itemValueName () {
      return this.returnValueName === '' ? this.itemValue : this.returnValueName
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    },
    filteredItems () {
      if (this.itemList === undefined) { return [] }
      return this.itemList.map(e => {
        const result = {
          ...e,
          value: e[this.itemValueName],
          text: `${e[this.itemValue]} : ${e[this.itemText]}`
        }
        return result
      })
    }
  },
  methods: {
    onBlur: function (e) {
      console.log('DdCodeTextBox.onBlur', e)
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
    },
    onFocus: function (e) {
    },
    onInput: function (e) {
      console.log('DdCodeTextBox.onInput', e, e.target.value)
      const elem = this.$el.querySelector('input')
      if (elem) { elem.select() }

      const val = e.target.value
      if (val === '') {
        this.value = { value: '' }
      }
    },
    onDialogButtonClick: function (e) {
      this.showDialog = true
    },
    onDialogClosed: function (e) {
      this.showDialog = false
      if (e === undefined) { return }
      this.innerValue = e[this.itemValueName]

      /**
       * dialog選択値inputイベント
       * @event input
       * @type {Event}
       */
      this.$emit('input', this.innerValue)
      this[controls.VALIDATE_METHOD]()
    },
    suggestFillter: function (item, queryText, itemText) {
      console.log('suggestFillter', item, queryText, itemText)
      const keys = !this.searchColumns ? Object.keys(item) : this.searchColumns
      for (let i = 0; i < keys.length; i++) {
        const v = String(item[keys[i]])
        if (v.indexOf(queryText) !== -1) { return true }
      }
      return false
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.innerValue,
        length: this.length
      }
      console.log(this)
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(this.valueType)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        console.log(target, f.name, ret)
        if (ret !== undefined) {
          this.invalidMessage = ret
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    }
  }
}
</script>
<style scoped>
</style>
